module.exports = __webpack_public_path__ + "static/img/class_10.787ad232.jpg";